/** Topsort ID pool size for sold PDP YMAL (grid up to 40 + optional carousel leftovers). */
export const SOLD_PDP_YMAL_SL_SIZE = 50;
export const SOLD_PDP_YMAL_SL_SUBSEQUENT = 15;
export const SOLD_PDP_YMAL_ITEMS_PER_ROW = 5;
export const SOLD_PDP_YMAL_SL_INITIAL = 10;
export const SOLD_PDP_YMAL_MAXIMUM_SIZE = 80;
/** Max display rows for sold PDP YMAL (SL5 + ML5 alternating). */
export const SOLD_PDP_YMAL_MAXIMUM_ROWS = 16;
/** Max sponsored tiles the grid can place 40. */
export const SOLD_PDP_YMAL_MAX_GRID_SPONSORED = 40;
export const SOLD_PDP_YMAL_FEATURED_CAROUSEL_CAPACITY = 10;

export const MAXIMUM_YMAL_ITEMS_COUNT = 40;
export const ML_ITEMS_INITIAL_COUNT = 10;
export const MORE_ML_ITEMS_FETCH_COUNT = 15;

/** 0-indexed row indices 0, 2, 4… — SL row then organic row, up to 16 rows. */
export const PDP_SPONSORED_ROW_INDICES: readonly number[] = Array.from(
    { length: SOLD_PDP_YMAL_MAXIMUM_ROWS / 2 },
    (_, i) => i * 2
);
